@if (content) {
@switch (!!content.hasOverride) {
<!-- local override -->
@case (true) {
<page-component-product-carousel [component]="content"></page-component-product-carousel>
}
<!-- default from layout -->
@default {
<icms-outlet [components]="defaultComponents"
             [allowOnly]="['advanced-commerce', 'product-carousel']"> </icms-outlet>
}
}
}